import { nextStep, prevStep } from '../../Camiones/reducers'

const initialState = {
  brutoStep: 0,
  destareStep: 0,
  repesoStep: 0,
  manualStep: 0,
  fueraDeCircuitoStep: 1,
  brutoSaveResponse: null,
  brutoShowSaveModal: false,
  repesoSaveResponse: null,
  repesoShowSaveModal: false,
  showCargaNoAdmitible: false,
  showReimpresionDestare: null,
  mensajeCargaNoAdmitible: '',
  cerealRemito: null,
  variedadRemito: null,
  consultaCeaLista: null,
  requestingConsultaCea: false,
  requestingCalificaciones: false,
  urlBruto: '',
  urlDestare: '',
  printerDestare: '',
  printerName: '',
  printerComprobanteDescarga: null,
  printerNameComprobanteDescarga: null,
  requestingCeaPendienteAutoriz: false,
  requestConsultaCea: false,
  receiveParametrosBruto: false,
  consultaCea: null,
  consultaCeaBruto: null,
  requestConsultaRemito: false,
  consultaRemito: null,
  pesajeBruto: '',
  pesajeDestare: '',
  balanzaBruto: '',
  balanzaDestare: '',
  pesoMaximo: 0,
  pesoMaximoDestare: 0,
  pesoMaximoAdvertencia: 0,
  pesoMaximoAdvertenciaDestare: 0,
  pesoMinimo: 0,
  pesoMinimoDestare: 0,
  pesoMinimoAdvertencia: 0,
  pesoMinimoAdvertenciaDestare: 0,
  pesoMinimoDiferenciaDestare: 100,
  equilibrioBruto: 1,
  enclavamientoDestare: 0,
  pesoDeCabezal: 0,
  pesoTara: 0,
  pesoRechazo: 0,
  urlOrigen: '',
  rechazoOK: false,
  consultaEjes: null,
  ultimoPesadoBruto: null,
  precargaDatos: null,
  numeroRemito: null,
  modoBarrerasDestare: '',
  modoBarrerasBruto: '',
  forzarBarrerasDestare: '',
  forzarBarrerasBruto: '',
  diferenciaTara: '',
  cpePesadoDestare: '',
  cpePesadoBruto: '',
  cerealAdherido: false,
  repesoDestare: '',
  descargaCpaTextValue: null,
  repesoBruto: 0,
  brutoSinEgresoCalado: 0,
  pedirConfirmacion: 1,
  camionesCalados: null,
  camionesPedidosBruto: null,
  themeModeBrutoChofer: 'dark',
  motivosActividadBarrera: null,
  isRequestingMotivosActBarrera: false,
  demoraDesdeEgreso: false,
  limiteDemoraDesdeEgreso: 45,
  estadoBarrerasDestare: '',
  enclavamientoBarrerasBruto: 0,
  enclavamientoBarrerasDestare: 0,
  fotoCeaBruto: null,
  callesDeBruto: null,
  actualizacionHabilitada: true
}

function calcularDiferenciaTara ({ pesoOrigen, pesoActual }, state) {
  state.diferenciaTara = (parseInt(pesoActual) - parseInt(pesoOrigen))
  return state.diferenciaTara
}

function diferenciaFechas (fecha1, fecha2) {
  const diferenciaMilisegundos = fecha1 - fecha2
  const diferenciaMinutos = diferenciaMilisegundos / 1000 / 60
  return diferenciaMinutos
}

function calcularDemoraDesdeEgreso ({ fechaActual, fechaEgresoCalado }, state) {
  const fechaEgreso = new Date(fechaEgresoCalado).getTime()
  state.demoraDesdeEgreso = (diferenciaFechas(fechaActual, fechaEgreso) > state.limiteDemoraDesdeEgreso)
  return state.demoraDesdeEgreso
}

export default function reducer (state = initialState, action) {
  switch (action.type) {
    case 'REQUEST_CONSULTA_CEA':
      return {
        ...state,
        requestConsultaCea: true
      }
    case 'RECEIVE_CONSULTA_CEA':
      return {
        ...state,
        requestConsultaCea: false,
        consultaCeaBruto: action.cea
      }
    case 'RECEIVE_CONSULTA_CEA_DESTARE':
      return {
        ...state,
        requestConsultaCea: false,
        consultaCeaDestare: action.cea
      }
    case 'RESET_CONSULTA_CEA_DESTARE':
      return {
        ...state,
        consultaCeaDestare: null
      }
    case 'REQUEST_BALANZA_URLS':
      return {
        ...state,
        urlBruto: '',
        urlDestare: ''
      }
    case 'REQUEST_CANTIDAD_EJES_CAMION_ACOPLADO':
      return {
        ...state
      }
    case 'RECEIVE_CANTIDAD_EJES_CAMION_ACOPLADO':
      return {
        ...state
      }
    case 'ESTABLECER_CANTIDAD_EJES_CAMION_ACOPLADO':
      return {
        ...state,
        consultaEjes: action.consultaEjes
      }
    case 'RECEIVE_BALANZA_URLS':
      return {
        ...state,
        urlBruto: action.urlBruto && action.urlBruto['valor'],
        urlDestare: action.urlDestare && action.urlDestare['valor']
      }
    case 'HIDE_SAVE_PESADO_BRUTO_MODAL':
      return {
        ...state,
        brutoSaveResponse: null,
        brutoShowSaveModal: false
      }
    case 'SUBMIT_BRUTO_RESPONSE':
      return {
        ...state,
        brutoShowSaveModal: action.saveStatus.error,
        brutoSaveResponse: action.saveStatus
      }
    case 'ACTUALIZAR_PESO_DE_CABEZAL':
      return {
        ...state,
        pesoDeCabezal: action.pesoDeCabezal
      }
    case 'REQUEST_CONSULTA_LISTA_PARA_BRUTO':
      return {
        ...state,
        requestingConsultaCea: true,
        consultaCeaLista: null
      }
    case 'RECEIVE_CONSULTA_LISTA_PARA_BRUTO':
      return {
        ...state,
        requestingConsultaCea: false,
        consultaCeaLista: action.consultaCeaLista
      }
    // case 'CANCEL_RECHAZO_PESADO':
    //   return {
    //     ...state,
    //     rechazoOK: false
    //   }
    case 'ACTUALIZAR_ULTIMO_PESADO':
      return {
        ...state,
        ultimoPesadoBruto: action.ultimoPesado
      }
    case 'ACTUALIZAR_PRECARGA_REMITO':
      return {
        ...state,
        precargaDatos: action.values
      }
    case 'RECHAZO_ESTABLECER_VALORES':
      return {
        ...state,
        pesoRechazo: action.pesoRechazo,
        urlOrigen: action.urlOrigen
      }
    case 'SHOW_BRUTO_NO_ADMITIBLE':
      return {
        ...state,
        showCargaNoAdmitible: true,
        mensajeCargaNoAdmitible: action.mensaje
      }
    case 'HIDE_BRUTO_NO_ADMITIBLE':
      return {
        ...state,
        showCargaNoAdmitible: false
      }
    case 'PROCESO_PESADO_BRUTO_NEXT_STEP':
      return {
        ...state,
        brutoStep: nextStep({ step: state.brutoStep, max: 1 })
      }
    case 'PROCESO_PESADO_BRUTO_PREV_STEP':
      return {
        ...state,
        destareStep: prevStep({ step: state.destareStep, max: 1 })
      }
    case 'PROCESO_PESADO_DESTARE_NEXT_STEP':
      return {
        ...state,
        destareStep: nextStep({ step: state.destareStep, max: 1 })
      }
    case 'PROCESO_PESADO_DESTARE_PREV_STEP':
      return {
        ...state,
        brutoStep: prevStep({ step: state.brutoStep, max: 1 })
      }
    // case 'PROCESO_REPESADO_BRUTO_NEXT_STEP':
    //   return {
    //     ...state,
    //     repesoStep: nextStep({ step: state.repesoStep, max: 1 })
    //   }
    // case 'PROCESO_REPESADO_BRUTO_PREV_STEP':
    //   return {
    //     ...state,
    //     repesoStep: prevStep({ step: state.repesoStep, max: 1 })
    //   }
    case 'PROCESO_FUERA_DE_CIRCUITO_NEXT_STEP':
      return {
        ...state,
        fueraDeCircuitoStep: nextStep({ step: state.fueraDeCircuitoStep, max: 1 })
      }
    case 'PROCESO_PESADO_MANUAL_NEXT_STEP':
      return {
        ...state,
        manualStep: nextStep({ step: state.manualStep, max: 2 })
      }
    case 'PROCESO_PESADO_MANUAL_PREV_STEP':
      return {
        ...state,
        manualStep: prevStep({ step: state.manualStep, max: 2 })
      }
    case 'END_PESADO_BRUTO':
      return {
        ...state,
        brutoStep: 0,
        brutoSaveResponse: null,
        brutoShowSaveModal: false
      }
    case 'END_PESADO_MANUAL':
      return {
        ...state,
        manualStep: 0,
        manualSaveResponse: null,
        manualShowSaveModal: false,
        consultaRemito: null,
        numeroRemito: 0
      }
    case 'END_REPESADO_BRUTO':
      return {
        ...state,
        repesoStep: 0,
        repesoSaveResponse: null,
        repesoShowSaveModal: false
      }
    case 'PROCESO_PESADO_HIDE_INVALIDO':
      return {
        ...state,
        brutoShowSaveModal: false
      }
    case 'UPDATE_THEME_MODE_BRUTO':
      return {
        ...state,
        themeModeBrutoChofer: action.newValue
      }
    case 'RECEIVE_MODO_PESAJE_BRUTO':
      return {
        ...state,
        pesajeBruto: action.pesajeBruto && action.pesajeBruto['valor']
      }
    case 'RECEIVE_REPESO_BRUTO':
      return {
        ...state,
        repesoBruto: action.repesoBruto && action.repesoBruto['valor']
      }
    case 'RECEIVE_EQUILIBRIO_BRUTO':
      return {
        ...state,
        equilibrioBruto: action.equilibrioBruto && action.equilibrioBruto['valor']
      }
    case 'RECEIVE_PEDIR_CONFIRMACION_CHOFER':
      return {
        ...state,
        pedirConfirmacion: action.pedirConfirmacion && action.pedirConfirmacion['valor']
      }
    case 'RECEIVE_ENCLAVAMIENTO_BARRERAS_BRUTO':
      return {
        ...state,
        enclavamientoBarrerasBruto: action.enclavamientoBarreras && action.enclavamientoBarreras['valor']
      }
    case 'RECEIVE_ENCLAVAMIENTO_BARRERAS_DESTARE':
      return {
        ...state,
        enclavamientoBarrerasDestare: action.enclavamientoBarreras && action.enclavamientoBarreras['valor']
      }
    case 'RECEIVE_PARAMETROS_BRUTO':
      return {
        ...state,
        pesajeBruto: action.pesajeBruto && action.pesajeBruto['valor'],
        balanzaBruto: action.balanzaBruto && action.balanzaBruto['valor'],
        urlBruto: action.urlBruto && action.urlBruto['valor'],
        forzarBarrerasBruto: action.forzarBarrerasBruto && action.forzarBarrerasBruto['valor'],
        modoBarrerasBruto: action.modoBarrerasBruto && action.modoBarrerasBruto['valor'],
        pesoMaximo: action.pesoMaximo && action.pesoMaximo['valor'],
        pesoMaximoAdvertencia: action.pesoMaximoAdvertencia && action.pesoMaximoAdvertencia['valor'],
        pesoMinimo: action.pesoMinimo && action.pesoMinimo['valor'],
        pesoMinimoAdvertencia: action.pesoMinimoAdvertencia && action.pesoMinimoAdvertencia['valor'],
        equilibrioBruto: action.equilibrioBruto && action.equilibrioBruto['valor'],
        repesoBruto: action.repesoBruto && action.repesoBruto['valor'],
        brutoSinEgresoCalado: action.brutoSinEgresoCalado && action.brutoSinEgresoCalado['valor'],
        pedirConfirmacion: action.pedirConfirmacion && action.pedirConfirmacion['valor'],
        limiteDemoraDesdeEgreso: action.limiteDemora && action.limiteDemora['valor'],
        enclavamientoBarrerasBruto: action.enclavamientoBarrerasBruto && action.enclavamientoBarrerasBruto['valor'],
        receiveParametrosBruto: true
      }
    case 'RECEIVE_PARAMETROS_DESTARE':
      return {
        ...state,
        pesajeDestare: action.pesajeDestare && action.pesajeDestare['valor'],
        balanzaDestare: action.balanzaDestare && action.balanzaDestare['valor'],
        urlDestare: action.urlDestare && action.urlDestare['valor'],
        printerDestare: action.printerDestare && action.printerDestare['valor'],
        modoBarrerasDestare: action.modoBarrerasDestare && action.modoBarrerasDestare['valor'],
        forzarBarrerasDestare: action.forzarBarrerasDestare && action.forzarBarrerasDestare['valor'],
        pesoMaximoDestare: action.pesoMaximoDestare && action.pesoMaximoDestare['valor'],
        pesoMaximoAdvertenciaDestare: action.pesoMaximoAdvertenciaDestare && action.pesoMaximoAdvertenciaDestare['valor'],
        pesoMinimoDestare: action.pesoMinimoDestare && action.pesoMinimoDestare['valor'],
        pesoMinimoAdvertenciaDestare: action.pesoMinimoAdvertenciaDestare && action.pesoMinimoAdvertenciaDestare['valor'],
        enclavamientoDestare: action.enclavamientoDestare && action.enclavamientoDestare['valor'],
        repesoDestare: action.repesoDestare && action.repesoDestare['valor'],
        enclavamientoBarrerasDestare: action.enclavamientoBarrerasDestare && action.enclavamientoBarrerasDestare['valor']
      }
    case 'MOSTRAR_MENSAJE_ADVERTENCIA':
      return {
        ...state
      }
    case 'MOSTRAR_MENSAJE_PESO_ORIGEN':
      return {
        ...state
      }
    case 'ENCLAVAR_BRUTO':
      return {
        ...state
      }
    case 'PESO_BRUTO_RESET_REMITO':
      return {
        ...state,
        requestConsultaRemito: false,
        consultaRemito: null
      }
    case 'PESO_BRUTO_REQUEST_REMITO':
      return {
        ...state,
        requestConsultaRemito: true,
        numeroRemito: action.numero,
        consultaRemito: null
      }
    case 'RESET_DATOS_REMITO':
      return {
        ...state,
        plantaRemito: null,
        numeroRemito: null
      //  exportadorRemito: null
      }
    case 'DATOS_BASE_REMITO':
      return {
        ...state,
        exportadorRemito: action.exportador,
        plantaRemito: action.planta
      }
    case 'SAVE_CEREAL_REMITO':
      return {
        ...state,
        cerealRemito: action.cereal
      }
    case 'SAVE_VARIEDAD_REMITO':
      return {
        ...state,
        variedadRemito: action.variedad
      }
    case 'PESO_BRUTO_RECEIVE_REMITO':
      return {
        ...state,
        requestConsultaRemito: false,
        consultaRemito: action.remito
      }
    case 'CPE_PESADO_DESTARE':
      return {
        ...state,
        cpePesadoDestare: action.data
      }
    case 'UPDATE_PESO_TARA':
      return {
        ...state,
        pesoTara: action.peso
      }
    case 'UPDATE_URL_DESTARE':
      return {
        ...state,
        urlDestare: action.url
      }
    case 'UPDATE_PESO_MAXIMO_DESTARE':
      return {
        ...state,
        pesoMaximoDestare: action.peso
      }
    case 'UPDATE_PESO_MAXIMO_ADVERTENCIA_DESTARE':
      return {
        ...state,
        pesoMaximoAdvertenciaDestare: action.peso
      }
    case 'UPDATE_PESO_MINIMO_DESTARE':
      return {
        ...state,
        pesoMinimoDestare: action.peso
      }
    case 'UPDATE_PESO_MINIMO_ADVERTENCIA_DESTARE':
      return {
        ...state,
        pesoMinimoAdvertenciaDestare: action.peso
      }
    case 'SET_BALANZA_BRUTO':
      return {
        ...state,
        balanzaBruto: action.balanza
      }
    case 'UPDATE_ENCLAVAMIENTO_BRUTO':
      return {
        ...state,
        equilibrioBruto: action.newValue
      }
    case 'UPDATE_ENCLAVAMIENTO_DESTARE':
      return {
        ...state,
        enclavamientoDestare: action.newValue
      }
    case 'PESADO_SIN_EGRESO_DE_CALADO':
      return {
        ...state,
        brutoSinEgresoCalado: action.newValue
      }
    case 'UPDATE_PEDIDO_CONFIRMACION':
      return {
        ...state,
        pedirConfirmacion: action.newValue
      }
    case 'UPDATE_FORZAR_BARRERAS_DESTARE':
      return {
        ...state,
        forzarBarrerasDestare: action.newValue
      }
    case 'UPDATE_FORZAR_BARRERAS_BRUTO':
      return {
        ...state,
        forzarBarrerasBruto: action.newValue
      }
    case 'UPDATE_MODO_PESADO_DESTARE':
      return {
        ...state,
        pesajeDestare: action.newValue
      }
    case 'UPDATE_ENCLAVAMIENTO_BARRERAS_BRUTO':
      return {
        ...state,
        enclavamientoBarrerasBruto: action.newValue
      }
    case 'UPDATE_ENCLAVAMIENTO_BARRERAS_DESTARE':
      return {
        ...state,
        enclavamientoBarrerasDestare: action.newValue
      }
    case 'UPDATE_MODO_PESADO_BRUTO':
      return {
        ...state,
        pesajeBruto: action.newValue
      }
    case 'UPDATE_CICLO_BARRERAS_DESTARE':
      return {
        ...state,
        modoBarrerasDestare: action.newValue
      }
    case 'UPDATE_CICLO_BARRERAS_BRUTO':
      return {
        ...state,
        modoBarrerasBruto: action.newValue
      }
    case 'UPDATE_SHOW_REIMPRESION_DESTARE':
      return {
        ...state,
        showReimpresionDestare: action.newValue
      }
    case 'CALCULAR_DIFERENCIA_TARA':
      return {
        ...state,
        diferenciaTara: calcularDiferenciaTara(action, state)
      }
    case 'RESET_DEMORA_DESDE_EGRESO':
      return {
        ...state,
        demoraDesdeEgreso: false
      }
    case 'CALCULAR_DEMORA_DESDE_EGRESO':
      return {
        ...state,
        demoraDesdeEgreso: calcularDemoraDesdeEgreso(action, state)
      }
    case 'RESET_DIFERENCIA_PESO_TARA':
      return {
        ...state,
        diferenciaTara: ''
      }
    case 'UPDATE_CONSULTA_CEA':
      return {
        ...state,
        consultaCea: action.value
      }
    case 'UPDATE_CPE_DESTARE':
      return {
        ...state,
        cpePesadoDestare: action.value
      }
    case 'UPDATE_CPE_BRUTO':
      return {
        ...state,
        cpePesadoBruto: action.value
      }
    case 'CPE_PESADO_BRUTO':
      return {
        ...state,
        cpePesadoBruto: action.data
      }
    case 'UPDATE_CEREAL_ADHERIDO':
      return {
        ...state,
        cerealAdherido: action.newValue
      }
    case 'UPDATE_REPESO_DESTARE':
      return {
        ...state,
        repesoDestare: action.newValue
      }
    case 'RESET_CPE_DESTARE':
      return {
        ...state,
        cpePesadoDestare: ''
      }
    case 'RESET_CPE_BRUTO':
      return {
        ...state,
        cpePesadoBruto: ''
      }
    case 'RESET_CEA_DESTARE':
      return {
        ...state,
        consultaCeaDestare: null
      }
    case 'RESET_CEA_BRUTO':
      return {
        ...state,
        consultaCeaBruto: null
      }
    case 'RESET_PRINTER_DESTARE':
      return {
        ...state,
        printerDestare: null,
        printerName: null
      }
    case 'SELECT_PRINTER_DESTARE':
      return {
        ...state,
        printerDestare: action.printer || null,
        printerName: action.printerName || null
      }
    case 'RESET_PRINTER_DESCARGA':
      return {
        ...state,
        printerComprobanteDescarga: null,
        printerNameComprobanteDescarga: null
      }
    case 'SELECT_PRINTER_DESCARGA':
      return {
        ...state,
        printerComprobanteDescarga: action.printerComprobanteDescarga || null,
        printerNameComprobanteDescarga: action.printerNameComprobanteDescarga || null
      }
    case 'DESCARGA_UPDATE_VALUE_CPA':
      return {
        ...state,
        descargaCpaTextValue: action.value
      }
    case 'RECEIVE_CAMIONES_CALADOS':
      return {
        ...state,
        camionesCalados: action.data
      }
    case 'RECEIVE_PEDIDOS_DE_BRUTO':
      return {
        ...state,
        camionesPedidosBruto: action.data
      }
    case 'REQUEST_MOTIVOS_ACTIVIDAD_BARRERA_BRUTO':
      return {
        ...state,
        isRequestingMotivosActBarrera: true
      }
    case 'MOTIVOS_ACTIVIDAD_BARRERA_BRUTO':
      return {
        ...state,
        motivosActividadBarrera: action.data,
        isRequestingMotivosActBarrera: false
      }
    case 'RESET_ESTADO_BARRERA_DESTARE':
      return {
        ...state,
        estadoBarrerasDestare: ''
      }
    case 'RECEIVE_ESTADO_BARRERAS_DESTARE':
      return {
        ...state,
        estadoBarrerasDestare: action.mensaje
      }
    case 'RECEIVE_FOTO_CEA_EN_BRUTO':
      return {
        ...state,
        fotoCeaBruto: action.data
      }
    case 'RESET_FOTO_CEA_EN_BRUTO':
      return {
        ...state,
        fotoCeaBruto: null
      }
    case 'CALLE_DE_BRUTO':
      return {
        ...state,
        callesDeBruto: action.calles
      }
    case 'UPDATE_ACTUALIZACION_HABILITADA':
      return {
        ...state,
        actualizacionHabilitada: action.newValue
      }
    default:
      return state
  }
}
